import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { $accountForIntegrationsStore } from '@lib/store';
import { useListState } from '@shared/hooks';
import type { IntegrationType } from '@shared/api/rest/integrations';
import type { AccountForIntegrationsRequest } from '@shared/api/rest/accounts';
import { Accounts, IntegrationTitle } from './widgets';
import { PageContainer } from '@shared/widgets';

export const IntegrationPage = () => {
  const params = useParams<{ id: IntegrationType }>();

  const [currency, setCurrency] = useState<string>();
  const integrationState = useListState({ list: 'integration' });

  const { t } = useTranslation('integration');

  useEffect(() => {
    const params: AccountForIntegrationsRequest = {
      Count: integrationState.count,
      FromIndex: integrationState.fromIndex,
      ReturnTotalCount: true,
      Currency: currency,
    };
    $accountForIntegrationsStore.events.getAccounts(params);
  }, [currency, integrationState]);

  return (
    <PageContainer title={t('title')} back backText={t('backText')}>
      <IntegrationTitle name={params.id!} currency={currency} onChangeCurrency={setCurrency} />
      <Accounts
        integration={params.id!}
        currency={currency}
        currentPage={integrationState.page}
        countItemPage={integrationState.count}
        onChangePage={integrationState.onChangePage}
        onChangeCountItemPage={integrationState.onChangeCount}
      />
    </PageContainer>
  );
};
